import styled from '@emotion/styled';
import React from 'react';

import SelectBox from '#/form/selectable-input/SelectBox';
import {Dropdown} from '#/form/selectable-input/SelectBox/styles';
import {ChevronSmallDown as OriginalChevronDown} from '_/assets/images';

import TabBarItem from './Item';

export const ChevronDown = (
  props: React.SVGAttributes<SVGElement>
): React.ReactElement => <OriginalChevronDown viewBox='4 4 8 8' {...props} />;

export const TabsContainer = styled.div`
  position: relative;
  display: flex;
  overflow: hidden;
  padding: var(--gutter-very-tiny);
  ${TabBarItem} {
    flex-shrink: 0;
  }
`;

export const FadeElementsContainer = styled.div`
  position: relative;
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
`;

export const LeftFade = styled.div`
  width: 16px;
  height: calc(100% - 4px);
  position: absolute;
  top: 2px;
  left: 0;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.2), transparent);
  pointer-events: none;
`;

export const RightFade = styled.div`
  width: 16px;
  height: calc(100% - 4px);
  position: absolute;
  top: 2px;
  right: 0;
  background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.2));
  pointer-events: none;
`;
export const StyledChevron = styled.div`
  align-self: center;
`;

export const ScrollWidthExtenderLeft = styled.div`
  flex-shrink: 0;
  min-width: 10px;
  border-bottom: var(--regular-border-width) solid var(--color-core-primary);
`;

export const ScrollWidthExtenderRight = styled.div`
  flex-shrink: 0;
  flex-grow: 1;
  min-width: 10px;
  border-bottom: var(--regular-border-width) solid var(--color-core-primary);
`;

export const StyledTabBar = styled.div`
  display: flex;
  overflow: hidden;
  margin: -2px;

  ${SelectBox} {
    display: flex;
    margin: var(--gutter-very-tiny) var(--gutter-tiny);
    align-self: center;

    &[aria-expanded='true'] {
      background-color: var(--color-state-active);
    }

    ${Dropdown} {
      width: 360px;
    }

    svg {
      fill: var(--color-core-black);
    }

    :not([aria-expanded='true']) svg {
      fill: var(--color-core-white);
    }

    :hover svg {
      fill: var(--color-menu-border-focus);
    }

    :hover[aria-expanded='true'] svg {
      fill: var(--color-core-black);
    }
  }
`;
